// src/components/VirtualTable.js
import React, { memo } from 'react';
import { TableRow, TableCell } from '@mui/material';
import { FixedSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { styled } from '@mui/material/styles';

const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'isEven',
})(({ isEven }) => ({
  display: 'flex',
  width: '100%',
  backgroundColor: isEven ? '#f5f5f5' : 'white',
  '&:hover': {
    backgroundColor: '#eeeef0',
  },
}));

const StyledTableCell = styled(TableCell)({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
});

// Row extracted outside VirtualTable so react-window can properly memoize it
const Row = memo(({ index, style, data }) => {
  const row = data[index];
  const isEven = index % 2 === 0;

  return (
    <StyledTableRow style={style} isEven={isEven}>
      <StyledTableCell>
        {row.type === 'ipv4' ? row.ip_prefix : row.ipv6_prefix}
      </StyledTableCell>
      <StyledTableCell>{row.region}</StyledTableCell>
      <StyledTableCell>{row.service}</StyledTableCell>
      <StyledTableCell>{row.type.toUpperCase()}</StyledTableCell>
    </StyledTableRow>
  );
});

const VirtualTable = memo(({ data }) => {
  return (
    <AutoSizer>
      {({ height, width }) => (
        <FixedSizeList
          height={height}
          width={width}
          itemCount={data.length}
          itemSize={48}
          itemData={data}
          overscanCount={5}
        >
          {Row}
        </FixedSizeList>
      )}
    </AutoSizer>
  );
});

export default VirtualTable;
